module.exports = __webpack_public_path__ + "static/media/vector.9cf76c73.png";